// import { jwtDecode } from 'jwt-decode'

// // Get token from localStorage
// export const getToken = () => {
//   return localStorage.getItem('livtoken')
// }

// // Check if token is expired
// // export const isTokenExpired = (token) => {
// //   if (!token) return true

// //   try {
// //     const decoded = jwtDecode(token)
// //      return decoded.exp < (Date.now() / 1000) + 30
// //     // const currentTime = Date.now() / 1000 // Convert to seconds
// //     // console.log(token);
    
// //     // Check if token is expired (with 60 second buffer)
// //     // return decoded.exp < currentTime
// //   } catch (error) {
// //     // console.error('Error decoding token:', error)
// //     return true // If can't decode, consider it expired
// //   }
// // }

// export const isTokenExpired = (token) => {
//   if (!token || token === 'undefined' || token === '[object Object]') return true
//   try {
//     const decoded = jwtDecode(token)
//     if (!decoded || !decoded.exp) return true
//     return decoded.exp < (Date.now() / 1000) + 30
//   } catch (error) {
//     return true
//   }
// }

// // Clear all auth data
// export const clearAuthData = () => {
//   localStorage.removeItem('livtoken')
//   localStorage.removeItem('user')
//     localStorage.removeItem('refresh_token')
//   // Add any other auth-related items you store
//   // Or use localStorage.clear() to clear everything
// }

// // Check token validity
// export const checkTokenValidity = () => {
//   const token = getToken()
  
//   if (!token) {
//     return false // No token
//   }
  
//   if (isTokenExpired(token)) {
//     // console.log("hjh");
    
//     clearAuthData()
//     return false // Token expired
//   }
  
//   return true // Token is valid
// }
// export const isAuthenticated = () => {
//   const token = getToken()
//   return !!token  // just "do we have a token at all?"
// }
import { jwtDecode } from 'jwt-decode'

// ─── Storage helpers ──────────────────────────────────────────────────────────

export const getAccessToken = () => localStorage.getItem('livtoken')
export const getRefreshToken = () => localStorage.getItem('refresh_token')

export const setTokens = (access, refresh) => {
  if (access) localStorage.setItem('livtoken', access)
  if (refresh) localStorage.setItem('refresh_token', refresh)
}

export const clearTokens = () => {
  localStorage.removeItem('livtoken')
  localStorage.removeItem('refresh_token')
}

// ─── Token inspection ─────────────────────────────────────────────────────────

/**
 * Returns true if the token is missing, malformed, or expires within 30 s.
 */
export const isTokenExpired = (token) => {
  if (!token || token === 'undefined' || token === '[object Object]') return true
  try {
    const { exp } = jwtDecode(token)
    if (!exp) return true
    return exp < Date.now() / 1000 + 30   // 30-second early-refresh buffer
  } catch {
    return true
  }
}

export const isAccessTokenExpired = () => isTokenExpired(getAccessToken())
export const hasRefreshToken     = () => Boolean(getRefreshToken())
export const isAuthenticated     = () => Boolean(getAccessToken())